import { FC, SVGTextElementAttributes } from "react";

interface Props extends SVGTextElementAttributes<SVGTextElement> {
    text: string
    tween: number
    fadeDuration: number
}

const CascadeText: FC<Props> = ({text, tween, fadeDuration, ...props}) => {
    
    const letters = [...text]

    return <text {...props}>
        {letters.map((l, i) => {
            const fadeStart = ((i / letters.length) * (1 - fadeDuration))
            const fadeEnd = fadeStart + fadeDuration
            const opacity = (tween < fadeStart) ? 0
                            : (tween > fadeEnd) ? 1
                                                : ((tween - fadeStart) / fadeDuration)
            return <tspan key={i} opacity={opacity}>{l}</tspan>
        })}
    </text>
}

export default CascadeText